<div class="flex flex-col md:grid grid-flow-col auto-cols-fr gap-2 md:gap-6 w-full px-0">
	@for (item of filters; track i; let i = $index) {
		@if (isMobile$ | async) {
			<app-top-search-filter
				(click)="openMobileModal(item.id)"
				[elementType]="item.isInput ? TopSearchFilterElType.INPUT : TopSearchFilterElType.BTN"
				[filter]="item"
				[style.--radius]="isDropdownOpenArray[i] ? '16px 16px 0 0' : '16px'"
				class="separator-line relative w-full md:mx-0 md:my-0 md:border-r md:border-mainColorLight md:pe-6 last:md:border-r-0"
			>
			</app-top-search-filter>
		} @else {
			<app-top-search-filter
				[filter]="item"
				[style.--radius]="'12px'"
				[appTriggerDropdown]="dropdown"
				[style.maxWidth.px]="itemMaxWidthPx"
				class="separator-line relative md:mx-0 md:my-0 md:border-r md:border-mainColorLight md:pe-6 last:md:border-r-0"
			>
				<app-dropdown
					[style.--radius]="'10px'"
					[style.--border-width]="'0 1px 1px 1px'"
					[style.--border-color]="'var(--main-color-light)'"
					[style.--shadow]="'0 0 12px rgb(0 0 0 / 8%)'"
					(dropdownStateChange)="changeOpenState($event, i)"
					(closeDropdownEvent)="fetchOffers(); changeOpenState(false, i)"
					class="dropdown"
					[centerHorizontally]="true"
					[width]="
						item.id === TopSearchDropdownItemMode.NIGHTS ||
						item.id === TopSearchDropdownItemMode.PARTICIPANTS
							? '300px'
							: item.id === TopSearchDropdownItemMode.DATE_RANGE
								? '500px'
								: '350px'
					"
					dropdown
					[scrollable]="false"
					#dropdown
				>
					<app-top-search-dropdown-item
						[mode]="item.id"
						(valueChange)="valueChange = $event"
						(triggerClose)="closeDropdown()"
					></app-top-search-dropdown-item>
				</app-dropdown>
			</app-top-search-filter>
		}
	}
</div>
